export const dataDefault = [{
    sort: 0,
    issues: "",
    plan: "",
    by: ""
}, {
    sort: 1,
    issues: "",
    plan: "",
    by: ""
}, {
    sort: 2,
    issues: "",
    plan: "",
    by: ""
}, {
    sort: 3,
    issues: "",
    plan: "",
    by: ""
}, {
    sort: 4,
    issues: "",
    plan: "",
    by: ""
}, {
    sort: 5,
    issues: "",
    plan: "",
    by: ""
}];


// WEBPACK FOOTER //
// ./src/components/table/other/meetingMinutes/data.js